import { useMemo } from 'react';
import { toISODate, addDays, monthLabels } from '../lib/dates';
import { getLogIntensity } from '../lib/streaks';

// GitHub-style heatmap (52 weeks)
export const Heatmap = ({ habit, logs }) => {
  const cells = useMemo(() => {
    const map = {};
    for (const l of logs || []) map[l.log_date] = l;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    // Start at Sunday roughly 52 weeks ago
    const start = addDays(today, -(52 * 7 - 1));
    while (start.getDay() !== 0) start.setDate(start.getDate() - 1);

    const weeks = [];
    let cursor = new Date(start);
    for (let w = 0; w < 53; w++) {
      const days = [];
      for (let d = 0; d < 7; d++) {
        const date = new Date(cursor);
        const key = toISODate(date);
        const log = map[key];
        days.push({ date, key, intensity: getLogIntensity(habit, log), inFuture: date > today, log });
        cursor.setDate(cursor.getDate() + 1);
      }
      weeks.push(days);
    }
    return weeks;
  }, [habit, logs]);

  const months = monthLabels();

  return (
    <div className="overflow-x-auto no-scrollbar" data-testid="habit-heatmap">
      <div className="inline-flex flex-col gap-1.5 min-w-full">
        {/* Month labels */}
        <div className="flex gap-1 pl-7 text-[10px] text-muted-foreground">
          {cells.map((w, i) => {
            const firstDay = w[0].date;
            const label = firstDay.getDate() <= 7 ? months[firstDay.getMonth()] : '';
            return (
              <div key={i} className="w-3 text-center" aria-hidden>
                {label}
              </div>
            );
          })}
        </div>
        <div className="flex gap-1">
          {/* Day labels */}
          <div className="flex flex-col gap-1 pr-1 text-[10px] text-muted-foreground">
            {['', 'Mon', '', 'Wed', '', 'Fri', ''].map((d, i) => (
              <div key={i} className="h-3 leading-3">{d}</div>
            ))}
          </div>
          {cells.map((w, wi) => (
            <div key={wi} className="flex flex-col gap-1">
              {w.map((cell, ci) => (
                <div
                  key={ci}
                  className={`h-3 w-3 rounded-[3px] heat-${cell.intensity} ${cell.inFuture ? 'opacity-30' : ''}`}
                  title={`${cell.key}${cell.log ? ' · ' + cell.log.status : ''}`}
                  data-testid={`heat-cell-${cell.key}`}
                />
              ))}
            </div>
          ))}
        </div>
        {/* Legend */}
        <div className="flex items-center gap-2 text-[10px] text-muted-foreground pt-1">
          Less
          <div className="h-3 w-3 rounded-[3px] heat-0" />
          <div className="h-3 w-3 rounded-[3px] heat-1" />
          <div className="h-3 w-3 rounded-[3px] heat-2" />
          <div className="h-3 w-3 rounded-[3px] heat-3" />
          <div className="h-3 w-3 rounded-[3px] heat-4" />
          More
        </div>
      </div>
    </div>
  );
};
